import { ActionButton, Selection, SelectionMode } from 'office-ui-fabric-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fieldTemplatesByFieldIdAndHearingTypeIdSelector } from '../../../../features/apiFeatures/fieldTemplateSlice';
import { fieldTypeEnumByIdSelector } from '../../../../features/apiFeatures/fieldTypeSlice';
import { getAttr } from '../../../../features/helpers/apiHelpers';
import { comparators } from '../../../../utilities/comparators';
import {
  filterAndSortingKeys,
  noSelectionKey,
} from '../../../../utilities/filterAndSortingsUtil';
import { FieldTemplateVisualList } from './FieldTemplateVisualList';
import { mapFieldTemplate } from './mapFieldTemplateItem';

const filterFieldTemplates = (filter) => (fieldTemplate) =>
  filter === noSelectionKey ||
  (getAttr(fieldTemplate, 'name') &&
    getAttr(fieldTemplate, 'name')
      .toLowerCase()
      .includes(filter.toLowerCase()));

const FieldTemplateList = ({
  fieldId,
  hearingTypeId,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
  selectedFieldTemplateKey,
  setSelectedFieldTemplateKey,
  createTemplate,
  fieldTypeId,
  setInitialFieldTemplateModelText,
}) => {
  const { t: translator } = useTranslation();

  const fieldTemplates = useSelector(
    fieldTemplatesByFieldIdAndHearingTypeIdSelector(hearingTypeId, fieldId),
  );
  const fieldTypeEnum = useSelector(fieldTypeEnumByIdSelector(fieldTypeId));

  const filteredFieldTemplates = fieldTemplates.filter(
    filterFieldTemplates(filterAndSortingSelection[filterAndSortingKeys.title]),
  );

  const itemsToRender = filteredFieldTemplates.map(mapFieldTemplate);

  const sortedItemsToRender = !!comparators.editFieldTemplates[
    filterAndSortingSelection[filterAndSortingKeys.sortingKey]
  ]
    ? itemsToRender.sort(
        comparators.editFieldTemplates[
          filterAndSortingSelection[filterAndSortingKeys.sortingKey]
        ],
      )
    : itemsToRender;

  const onSelectionChanged = () => {
    const [selection] = listSelection.getSelection();
    setSelectedFieldTemplateKey(selection && selection.key);
    setInitialFieldTemplateModelText('');
  };

  const [listSelection] = useState(
    new Selection({
      onSelectionChanged: onSelectionChanged,
      selectionMode: SelectionMode.single,
    }),
  );

  useEffect(() => {
    sortedItemsToRender.find((x) => x.key === selectedFieldTemplateKey) ||
      listSelection.setAllSelected(false);
  }, [selectedFieldTemplateKey, listSelection, sortedItemsToRender]);

  const onAddButtonPress = () => {
    createTemplate(fieldId);
  };

  return (
    <div className="fieldTemplate-row-stack-buttons">
      <div>
        <FieldTemplateVisualList
          items={sortedItemsToRender}
          onFieldTemplateClick={(fieldTemplateId) => {
            setSelectedFieldTemplateKey(fieldTemplateId);
            setInitialFieldTemplateModelText('');
          }}
          filterAndSortingSelection={filterAndSortingSelection}
          setFilterAndSortingSelection={setFilterAndSortingSelection}
          listSelection={listSelection}
          fieldTypeEnum={fieldTypeEnum}
        />
      </div>
      <div className="fieldTemplate-page-buttons">
        <ActionButton
          text={translator('global.add')}
          iconProps={{ iconName: 'Add' }}
          onClick={onAddButtonPress}
        />
      </div>
    </div>
  );
};
export { FieldTemplateList };
